<template>
  <div>
    <a-form class="custom-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item label="套餐名称">
            <a-input
              v-decorator="['package_name', {
                normalize: this.$lodash.trim
              }]"
              placeholder="请输入套餐名称"
              allow-clear
              autocomplete="off"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="状态">
            <a-select
              v-decorator="['effective', {initialValue: 'true'}]"
              placeholder="请选择状态"
              allow-clear
            >
              <a-select-option key="true" value="true">
                生效
              </a-select-option>
              <a-select-option key="false" value="false">
                失效
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6" v-if="!isOutfieldServicePlace">
          <a-form-item label="所属殡仪馆">
            <a-select
              :loading="loadingFuneralHomeOptions"
              placeholder="请选择所属殡仪馆"
              mode="multiple"
              @focus="fetchFuneralHomeOptions"
              v-decorator="['funeral_home_ids']"
            >
              <a-select-option
                v-for="home in funeralHomeOptions"
                :key="home.id"
                :value="home.id"
              >
                {{ home.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>
<script>
import { findAllFuneralHomeOptions } from '@/api/funeral_home'

export default {
  name: 'SearchTenantPackage',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'tenant_package_search' }),
      funeralHomeOptions: [],
      loadingFuneralHomeOptions: false
    }
  },
  computed: {
    isOutfieldServicePlace() {
      return this.$store.getters.tenantServicePlace === 'outfield'
    }
  },
  methods: {
    fetchFuneralHomeOptions() {
      this.loadingFuneralHomeOptions = true
      findAllFuneralHomeOptions().then((res) => {
        this.funeralHomeOptions = res.data
      })
      this.loadingFuneralHomeOptions = false
    },

    handleSearch(e) {
      e.preventDefault()
      this.$emit('submit', this.form.getFieldsValue())
    },

    clearForm() {
      this.form.setFieldsValue({ effective: undefined })
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>

